import { render } from "./AIAnalysisView.vue?vue&type=template&id=28525b4c&scoped=true"
import script from "./AIAnalysisView.vue?vue&type=script&lang=js"
export * from "./AIAnalysisView.vue?vue&type=script&lang=js"

import "./AIAnalysisView.vue?vue&type=style&index=0&id=28525b4c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28525b4c"]])

export default __exports__